import CtaButton from '@/atoms/Buttons/CTA/CtaButton';
import {useEffect, useState} from 'react';
import useAuth from '../../hooks/use-auth/use-auth';
import {get, urlencoded} from '../../services/artfinder-service';
import _ from '../../utils/_';
import {emit, emitFactory} from '../../utils/events';
import {followArtistEvent} from '../../utils/gtm';
import ArtistAvatar from '../artist-avatar/artist-avatar';
import Button from '../button/button';
import Rating from '../rating/rating';
import {H2} from '../typography/typography';
import './artist-menu.scss';

const artistUrl = (slug) => `/artist/${slug}/availability-true/`;

const ArtistMenu = ({artist}) => {
  const [isFollowing, setIsFollowing]: any = useState(false);
  const auth = useAuth();

  const getAndSetFollowing = () => {
    get('/interest/follows.js')
      .then(_.pipe(_.includes(artist.slug), setIsFollowing))
      .catch((err) => {
        console.log('interest follow api error', err);
      });
  };

  const toggleFollow = () => {
    if (!auth.isAuthenticated()) {
      emit('CLICK_ON_JOIN');
      return;
    }
    urlencoded('/interest/', {
      object_type: 'artists.Artist',
      object_id: artist.id,
      interested: !isFollowing,
    })
      .then(() => {
        getAndSetFollowing();
        followArtistEvent(artist);
      })
      .catch((err) => {
        console.log('artist follow error', err);
      });
  };

  useEffect(getAndSetFollowing, []);

  return (
    <div className="artist-menu">
      <ArtistAvatar
        alt={`Visit ${artist.name} shop`}
        src={artist.avatar_url}
        url={artistUrl(artist.slug)}
      />

      <div>
        <a href={artistUrl(artist.slug)}>
          <H2 style="section">{artist.name}</H2>
        </a>

        {artist.review_data.review_count && (
          <div>
            <Rating value={artist.review_data.seller_rating} size="18px" />
            &nbsp;
            <span>({artist.review_data.review_count})</span>
          </div>
        )}

        <div className="button-group">
          <Button
            icon="heart"
            active={isFollowing}
            onClick={toggleFollow}
            title={isFollowing ? `Unfollow ${artist.name}` : `Follow ${artist.name}`}
          />

          <CtaButton
            onClick={emitFactory('CLICK_CONTACT_ARTIST')}
            title={`Contact ${artist.name}`}
            style="tertiary"
          >
            Contact me
          </CtaButton>
        </div>
      </div>
    </div>
  );
};

export default ArtistMenu;
